import {addEventByClassName, addEventById, getElementById, getValueById} from "./helpers";
import {Ajax} from "./ajax";

export const Authentication = {
    init: function () {
        addEventByClassName('click', 'js-auth-change-tab', this.changeTab)

        addEventById('submit', 'form-login', this.auth.login)
        addEventById('submit', 'form-register', this.auth.register)
        addEventById('submit', 'form-forgot', this.auth.forgot)
        addEventById('submit', 'form-reset', this.auth.reset)
    },
    changeTab: function (event) {
        event.preventDefault()

        Array.from(document.getElementsByClassName('js-auth-tab'))
            .forEach(el => el.classList.add('none'));

        document.getElementById(event.target.dataset.tab).classList.remove('none')
    },
    auth: {
        login: function (event) {
            event.preventDefault()

            const formData = new FormData();
            formData.append('login_email', getValueById('login_email'));
            formData.append('login_password', getValueById('login_password'));

            Ajax.POST('/auth/login', formData).then(function (response) {
                Authentication.auth.clearErrors()
                window.location.href = response.data.data.redirect;
            }).catch(function (errors) {
                Authentication.auth.showErrors(errors.response.data.errors)
            })
        },
        register: function (event) {
            event.preventDefault()

            const formData = new FormData();
            formData.append('register_email', getValueById('register_email'));
            formData.append('register_promo_code', getValueById('register_promo_code'));
            formData.append('register_is_agree', getElementById('register_is_agree').checked ? 1 : '');

            Ajax.POST('/auth/register', formData).then(function (response) {
                Authentication.auth.clearErrors()
                window.location.href = response.data.data.redirect;
            }).catch(function (errors) {
                Authentication.auth.showErrors(errors.response.data.errors)
            })
        },
        forgot: function (event) {
            event.preventDefault()

            const formData = new FormData();
            formData.append('forgot_email', getValueById('forgot_email'));

            Ajax.POST('/auth/forgot', formData).then(function (response) {
                Authentication.auth.clearErrors()
                alert(response.data.message)
                getElementById('js-open-login').click()
            }).catch(function (errors) {
                Authentication.auth.showErrors(errors.response.data.errors)
            })
        },
        showErrors: function (errors) {
            Authentication.auth.clearErrors()

            for (const i in errors) {
                document.getElementById(i + '_error').innerHTML = ''
                document.getElementById(i + '_error').classList.remove('none')
                document.getElementById(i + '_error').insertAdjacentHTML('afterBegin', errors[i][0])
            }
        },
        clearErrors: function () {
            Array.from(document.getElementsByClassName('form-field-error'))
                .forEach(el => el.classList.add('none'));
        }
    },
}
